import { GetterTree } from 'vuex';
import { RootState } from '../store';
import { SessionState } from '../stores/session.store';
import { ICurrency } from '@/types/Currency';
import { EnumUserRoles } from '@/enums/UserRole';
import { getCurrency } from '@/common/currency';
import { IUser } from '@/types/User';

export const getters: GetterTree<SessionState, RootState> = {
  currency: (state: SessionState): ICurrency =>
    getCurrency(state.session.currency) || getCurrency('USD'),
  showManager: (state: SessionState): boolean =>
    [EnumUserRoles.manager, EnumUserRoles.admin].includes(state.session.user_role),
  showAdmin: (state: SessionState): boolean => EnumUserRoles.admin === state.session.user_role,
  user: (state: SessionState): IUser => ({
    id: state.session.user_hash,
    name: state.session.full_name,
    firstName: state.session.first_name,
    lastName: state.session.last_name,
  }),
};
